module.exports = __webpack_public_path__ + "static/media/lesotho-flag-round-small.33e715eb.jpg";